import { IRefIds } from 'constants/refs';
import { post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IMultiNavigationData } from 'types/navigation';

export type IPatternFrequencyRow = {
  id: number;
  navigation_data: IMultiNavigationData;
  count: number;
  pattern: string;
  actions: boolean;
};

export type IPatternFrequencyConfig = {
  filtering: { courses: { course_id: number; klines?: number[] }[] };
  dialect: number | string;
  refs: number[];
};

export default class MemoryPatternFrequencyModel extends BaseModel<IPatternFrequencyRow> {
  dialectId = 0;
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.memory;
    this.gridName = 'MemoryPatternFrequency';
    this.getGridColumns();
  }

  async loadWithConfig(config: IPatternFrequencyConfig) {
    this.cancelGetGrid();
    this.loadingGrid = true;
    this.render();
    const response = await post<IPatternFrequencyRow[]>(`memory/patterns`, config);
    if (response && response.data) {
      // Adapt rows to include items[] for change modal, carrying translation and panel ids
      const adapted = (response.data as any[]).map((r) => ({
        ...r,
        items: Array.isArray(r.id_map)
          ? r.id_map.map((m: any) => ({
              translation_id: m.translation_id,
              course_id: m.course_id,
              panel_id: m.panel_id,
            }))
          : [],
      }));
      this.gridData = adapted as any;
    }
    this.loadingGrid = false;
    this.render();
  }

  setDialectId(id: number) {
    this.dialectId = id;
  }

  // Allow Grid to refresh an updated row by id
  async getGridRow(itemId: number) {
    const row = (this.gridData as any[]).find((r) => r && r.id === itemId);
    return row || { id: itemId };
  }

  // Mark a row as changed and update its pattern locally
  async applyMemberChange(rowId: number, editedPattern?: string) {
    const rows: any[] = Array.isArray(this.gridData) ? (this.gridData as any) : [];
    const idx = rows.findIndex((r) => r && r.id === rowId);
    if (idx !== -1) {
      const next = { ...rows[idx], __changed: true } as any;
      if (editedPattern) next.pattern = editedPattern;
      rows[idx] = next;
      this.gridData = rows.slice();
      this.render();
      await this.updateGridRow(rowId, 'update');
    }
  }
}
